import { getProrations, GetProrationsReturn } from 'graphql/prorations/queries';
import { UseQueryOptions, useQuery } from 'react-query';

type Params = {
  orderId: string;
  queryConfig?: UseQueryOptions<GetProrationsReturn, Error, GetProrationsReturn, any>;
};

export const useGetProrations = ({ orderId, queryConfig }: Params) =>
  useQuery([{ orderId }, 'prorations'], () => getProrations({ orderId }), {
    ...queryConfig,
    enabled: !!orderId && queryConfig?.enabled !== false,
  });
